import * as React from "react";
import { RadioButtonGroup } from "@grandvisionhq/common";
import { Field } from "@grandvisionhq/forms";
const cancelOtherReason = "CANCEL_OTHER";
const CancelAppointmentReasons = ({ reasons }) => {
  return /* @__PURE__ */ React.createElement(Field, { error: "error", name: "cancellationReason" }, /* @__PURE__ */ React.createElement(RadioButtonGroup, { onChange: () => null, scope: "cancellationReason", items: reasons }));
};
export {
  CancelAppointmentReasons,
  cancelOtherReason
};
//# sourceMappingURL=CancelAppointmentReasons.js.map
